module.exports = __webpack_public_path__ + "static/media/lily.d8c92d87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/project/lily.jpg
// module id = 475
// module chunks = 0